<template>
    <div>
        <p class="font-weight-bold"> Crew List </p>
        <div class="row text-small">
            <div class="col-sm-4">
                <table class="table table-sm">
                    <tbody>
                    <tr>
                        <th scope="row" class="align-middle">Crew Compliment</th>
                        <td class="align-middle">18</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Full Crew</th>
                        <td class="align-middle">MIX</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Filipino Crew</th>
                        <td class="align-middle">16</td>
                    </tr>
                    <tr class="border-bottom">
                        <th scope="row" class="align-middle">Foreign Crew</th>
                        <td class="align-middle">2</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row text-small text-center">
            <div class="col-sm-12">
                <table class="table table-sm table-hover table-bordered" id="crewListTable">
                    <thead class="bg-light">
                    <tr>
                        <th class="align-middle" scope="col" rowspan="2">#</th>
                        <th class="align-middle" scope="col" rowspan="2">Rank</th>
                        <th class="align-middle" scope="col" rowspan="2">Crew Name</th>
                        <th class="align-middle" scope="col" rowspan="2">Nationality</th>
                        <th class="align-middle" scope="col" colspan="2">Embarkation</th>
                        <th class="align-middle" scope="col" colspan="2">Disembarkation</th>
                        <th class="align-middle" scope="col" rowspan="2">Months Remaining</th>
                        <th class="align-middle" scope="col" rowspan="2">Action</th>
                    </tr>
                    <tr>
                        <th class="align-middle" scope="col">Date</th>
                        <th class="align-middle" scope="col">Port</th>
                        <th class="align-middle" scope="col">Date</th>
                        <th class="align-middle" scope="col">Port</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row" class="align-middle">1</th>
                        <td class="align-middle">MTR</td>
                        <td class="align-middle">Joseph Phillips</td>
                        <td class="align-middle">Filipino</td>
                        <td class="align-middle">21-Jan-16</td>
                        <td class="align-middle">AEAUH</td>
                        <td class="align-middle">12-Sept-16</td>
                        <td class="align-middle">AEJEA</td>
                        <td class="align-middle">7</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">2</th>
                        <td class="align-middle">C/E</td>
                        <td class="align-middle">Ivan Clark</td>
                        <td class="align-middle">Bulgarian</td>
                        <td class="align-middle">6-Apr-18</td>
                        <td class="align-middle">AEDXB</td>
                        <td class="align-middle">15-Jan-19</td>
                        <td class="align-middle">AEKHF</td>
                        <td class="align-middle">3</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">3</th>
                        <td class="align-middle">C/M</td>
                        <td class="align-middle">Kennedy Rivera</td>
                        <td class="align-middle">Japanese</td>
                        <td class="align-middle">7-Aug-19</td>
                        <td class="align-middle">AEFJR</td>
                        <td class="align-middle">8-Nov-20</td>
                        <td class="align-middle">AEKHL</td>
                        <td class="align-middle">2</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name: "VesselCrewList"
}
</script>

<style scoped>

</style>
